var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPhonelinkGradient24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0033AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0033AD"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M5.333 3h24V.333h-24A2.675 2.675 0 0 0 2.667 3v14.667H0v4h18.667v-4H5.333V3zm25.334 2.667h-8c-.734 0-1.334.6-1.334 1.333v13.333c0 .734.6 1.334 1.334 1.334h8c.733 0 1.333-.6 1.333-1.334V7c0-.733-.6-1.333-1.333-1.333zm-1.334 12H24V8.333h5.333v9.334z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhonelinkGradient24Px);
export default __webpack_public_path__ + "static/media/ic-phonelink-gradient-24-px.e1a68df7917faa0dc906bdfedfeaf7e3.svg";
export { ForwardRef as ReactComponent };